<template>
    <div class="detail-body">
        <iframe
                :src="iframeUrl"
                frameborder="0"
                id="bdIframe"
                allowtransparency
                ref="iframe"
        ></iframe>
    </div>
</template>
<script>
    let _this = null;
    export default {
        name: 'dashboard-index',
        data() {
            return {
                activeName: 'first',
                iframeUrl: '',
                dashboardList: ''
            }
        },
        created() {
            _this = this;
        },
        mounted() {
            _this = this;
            _this.getData();
        },
        methods: {
            getData() {
                let tab = this.$route.params.tab
                if(!tab){
                    return
                }
                this.$http.get(`/auth/setting/view/${tab}/`)
                    .then(resp => {
                        var data = resp.data.data
                        var jwt = require("jsonwebtoken");
                        var METABASE_SITE_URL = data.url;
                        var METABASE_SECRET_KEY = data.token;
                        var dashboard = 1
                        var theme = data.theme
                        if(tab){
                            dashboard = parseInt(tab)
                        }
                        var username = localStorage.getItem('username') || ''
                        var payload = {
                            resource: {dashboard: dashboard},
                            params: {},
                            exp: Math.round(Date.now() / 1000) + (10 * 60) // 10 minute expiration
                        };
                        if (data.key) {
                            payload.params[data.key] = [username]
                        }
                        var token = jwt.sign(payload, METABASE_SECRET_KEY);
                        this.iframeUrl = METABASE_SITE_URL + token + `#bordered=true&titled=true&theme=${theme}`;
                    })
                    .catch((err) => {
                        console.log(err)
                    })
                  const oIframe = document.getElementById('bdIframe');
                  const deviceHeight = document.documentElement.clientHeight;
                  oIframe.style.height = (Number(deviceHeight) - 10) + 'px';
            },
        },
    };
</script>
<style scoped>
    .detail-body {
        width: 100%;
        /*height: 100vh;*/
        position: relative;
    }

    iframe {
        width: 100%;
        height: 100%;
        /*border: none;*/
    }
</style>